import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material';
import { useAppSelector } from '../../../store/app/hooks';
import { RootState } from '../../../store/app/store';
import Dropdown from './Dropdown';
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
	const backgroundColor =
		theme.palette.mode === 'light'
			? theme.palette.grey[100]
			: theme.palette.grey[800];
	return {
		backgroundColor,
		height: theme.spacing(3),
		color: theme.palette.text.primary,
		fontWeight: theme.typography.fontWeightRegular,
		'&:hover, &:focus': {
			backgroundColor: emphasize(backgroundColor, 0.06)
		},
		'&:active': {
			boxShadow: theme.shadows[1],
			backgroundColor: emphasize(backgroundColor, 0.12)
		}
	};
}) as typeof Chip;


const BreadcrumbNav = ({redirectToHome}: {redirectToHome: boolean}): React.ReactElement => {
	const areBreadcrumbsEnabled = useAppSelector(
		(state: RootState) => state.breadcrumbs.isEnabled);
	const isClientDropDownNeeded = useAppSelector(
		(state: RootState) => state.breadcrumbs.isClientDropDownNeeded);
	const isReportClientDropDownNeeded = useAppSelector(
		(state: RootState) => state.breadcrumbs.isReportClientDropDownNeeded);
	const capitalizeFirstLetter = (crumbTitle: string) => {
		return crumbTitle.charAt(0).toUpperCase() + crumbTitle.slice(1);
	};
	const { dropDownData, crumbs, clientDropDownData, selectedClient, reportClientDropDownData, 
		selectedReportClient, reportEngagementDropDownData, selectedReportEngagement } = useAppSelector((state: RootState) => state.breadcrumbs);

	const breadCrumbs = [
		<Link key={'homeNav'} to="/" className={'breadcrumb-link-style'}>
			<StyledBreadcrumb component="a" href="#" label="Home" />
		</Link>
	];

	if (crumbs.path) {
		crumbs.path.map((c) => {
			breadCrumbs.push(
				<Link key={c.title} to={c.link!}>
					{capitalizeFirstLetter(c.title!)}
				</Link>
			);
		});
	};

	useEffect(() => {
	}, [areBreadcrumbsEnabled, isClientDropDownNeeded, isReportClientDropDownNeeded]);

	return (
		<div>
			{areBreadcrumbsEnabled ? (
					<Breadcrumbs>
						<StyledBreadcrumb component="a" 
							href={redirectToHome ? "/" : "/admin/workspaces" }
							label={redirectToHome ? "Home" : "Workspaces"}
							style={{cursor:'pointer'}}
						/>
						<StyledBreadcrumb
							label={dropDownData.length > 0 ? (
								<Dropdown
									data={crumbs.children?.data ?? []}
									currentOption={crumbs.children?.selectedId ?? ''}
									isClientDropDownNeeded = {isClientDropDownNeeded}
									isClientDropDown={false}
									isReportClientDropDownNeeded = {isReportClientDropDownNeeded}
									isReportClientDropDown={false}
									isReportEngagementDropDown={false}
								/>
							) : null}
						/>
						{isClientDropDownNeeded ? (
							<StyledBreadcrumb
								label={
								clientDropDownData.length > 0 ? (
									<Dropdown
									data={clientDropDownData ?? []}
									currentOption={selectedClient ?? ''}
									isClientDropDownNeeded={false}
									isClientDropDown={true}
									isReportClientDropDownNeeded={false}
									isReportClientDropDown={false}
									isReportEngagementDropDown={false}
									/>
								) : null
								}
							/>
						) : isReportClientDropDownNeeded ? (
							<StyledBreadcrumb
								label={
								reportClientDropDownData.length > 0 ? (
									<Dropdown
									data={reportClientDropDownData}
									currentOption={selectedReportClient}
									isClientDropDownNeeded={false}
									isClientDropDown={false}
									isReportClientDropDownNeeded={false}
									isReportClientDropDown={true}
									isReportEngagementDropDown={false}
									/>
								) : null
								}
							/>
						) : null}
						{isReportClientDropDownNeeded && reportEngagementDropDownData && reportEngagementDropDownData.length > 0 ? (
							<StyledBreadcrumb
								label={
									<Dropdown
										data={reportEngagementDropDownData}
										currentOption={selectedReportEngagement}
										isClientDropDownNeeded={false}
										isClientDropDown={false}
										isReportClientDropDownNeeded={false}
										isReportClientDropDown={false}
										isReportEngagementDropDown={true}
									/>
								}
							/>
						) : null}
					</Breadcrumbs>
				)
				: null
			}
		</div>
	);
};

export default React.memo(BreadcrumbNav);
